<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-commenting text-primary mr-2"></i>
                    Editar Consulta
                </h4>
            </b-col>
        </b-row>

        <b-row class="py-2">
            <b-col sm="12" md="6">
                <b-card>
                    <query-form
                        :emitSubmitEvent="submitQueryForm"
                        :headquarters="authUser().headquarters"
                        :initialQuery="initialQuery"
                        :limitForm="false"
                        @submit-query-form="updateQuery($event)">
                    </query-form>
                </b-card>
            </b-col>

            <b-col sm="12" md="6">
                <b-card>
                    <b-row v-if="!!client.uuid" slot="header">
                        <b-col xs="12">
                            <template v-if="isMemberQuery">Socio</template>
                            <template v-else>No Socio</template>
                        </b-col>
                    </b-row>

                    <b-row class="animated fadeIn">
                        <b-col xs="12">
                            <member-summary v-if="!!client.uuid && isMemberQuery" :member="client" :headquarters="query.headquarters"></member-summary>
                            <client-summary v-else-if="!!client" :client="client"></client-summary>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-row v-if="mixinCheckPermission('QUERY_NEW')" class="flex-row-reverse px-3 mb-3 mt-2">
            <button :disabled="!client" class="btn btn-brand btn-primary btn-lg" @click="submitQueryForm=true">
                Guardar
            </button>
        </b-row>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import QueryForm from './QueryForm';
    import MemberSummary from '@/components/clients/members/MemberSummary';
    import ClientSummary from '@/components/clients/ClientSummary';
    import {updateQuery, getQuery} from '@/api/query-api';
    import {getCnaes} from '@/api/cnae-api';
    import {getMember} from '@/api/member-api';
    import {getClient} from '@/api/client-api';

    export default {
        name: "EditQuery",
        components: {
            QueryForm,
            MemberSummary,
            ClientSummary
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/queries/overview/' + this.$route.params.uuid,
                        brand: 'fa fa-arrow-left'
                    }
                ],
                tabIndex: 0,
                query: {
                    uuid: null,
                    client: null
                },
                client: {
                    uuid: null
                },
                cnaes: null,
                submitQueryForm: false
            }
        },
        computed: {
            satisfiedDependencies() {
                return (
                    !!this.query.uuid
                    && !!this.client.uuid
                    && !!this.cnaes
                );
            },
            isMemberQuery() {
                return (
                    !!this.query.client
                    && !!this.query.client.uuid
                    && !!this.query.client.class
                    && this.query.client.class === 'Member'
                );
            },
            initialQuery() {
                if (this.satisfiedDependencies) {
                    return {
                        headquarters: this.authUser().headquarters.find(headquarters => (headquarters.uuid === this.query.headquarters.uuid)),
                        urgent: this.query.urgent,
                        potentialMember: this.query.potentialMember,
                        description: this.query.description,
                        comment: this.query.comment,
                        origin: this.query.origin,
                        date: new Date(this.query.date),
                        category: this.query.category,
                        adviser: this.query.adviser,
                        associatedProjects: this.query.associatedProjects,
                        status: this.query.status
                    };
                } else {
                    return null
                }
            }
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQuery(this.$route.params.uuid);
            this.getCnaes();
        },
        methods: {
            ...mapGetters([
                'authUser',
            ]),
            async getQuery(queryId) {
                this.$_loadingMixin_showLoading();
                await getQuery(queryId)
                    .then((query) => {
                        this.query = query;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getClient(clientId) {
                this.$_loadingMixin_showLoading();
                await getClient(clientId)
                    .then((client) => {
                        this.client = client;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getMember(memberId) {
                this.$_loadingMixin_showLoading();
                await getMember(memberId)
                    .then((member) => {
                        this.client = member;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async getCnaes() {
                this.$_loadingMixin_showLoading();
                await getCnaes()
                    .then((cnaes) => {
                        this.cnaes = cnaes;
                    })
                    .catch(() => {
                        this.cnaes = [];
                    });
                this.$_loadingMixin_hideLoading();
            },
            validateQuery(query) {
                return !!query.description;
            },
            updateQuery(query) {
                console.log(query);
                let queryObject = Object.assign({}, query, {client: this.client});
                if (this.validateQuery(queryObject)) {
                    this.updateQueryRequest(queryObject)
                } else {
                    this.$_notificationMixin_error('La datos no son válidos', 'Revise la consulta')
                }
                this.submitQueryForm = false;
            },
            async updateQueryRequest(query) {
                this.$_loadingMixin_showLoading();
                await updateQuery(
                    this.query.uuid,
                    query.categoryAdvisers.map((item) => {
                      return {
                        categoryId: item.category.uuid,
                        adviserId: item.adviser.uuid
                      }
                    }),
                    query.date,
                    query.headquarters.uuid,
                    query.origin,
                    query.description,
                    query.comment,
                    query.urgent,
                    query.potentialMember,
                    query.status,
                    query.associatedProjects
                )
                    .then(() => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$router.push({path: '/queries/overview/' + this.query.uuid});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    });
                this.$_loadingMixin_hideLoading();
            }
        },
        watch: {
            query: function (val) {
                if (
                    !!this.query.client
                    && !!this.query.client.uuid
                    && !!this.query.client.class
                ) {
                    if (this.isMemberQuery) {
                        this.getMember(this.query.client.uuid);
                    } else {
                        this.getClient(this.query.client.uuid);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
